import { usePersonal } from 'pages/Personal/hooks';
import { useAppProvider } from 'providers';

import { CardDetailsWS } from './forms/CardDetailsWS';

export const CardDetails = () => {
  const { isProfileLoaded, profile } = usePersonal();
  const { isPersistDone } = useAppProvider();

  if (isPersistDone && isProfileLoaded && !!profile) {
    return <CardDetailsWS />;
  }

  return null;
};
